"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("reshow-runtime/helpers/toConsumableArray"));
var _react = require("react");
var _reshowBuild = _interopRequireDefault(require("reshow-build"));
var mergeChildren = function mergeChildren(vDom, children, isAppend) {
  var myDom = (0, _reshowBuild["default"])(vDom)({
    key: "merge"
  });
  if (isAppend) {
    return [].concat((0, _toConsumableArray2["default"])(_react.Children.map(children, function (c) {
      return c;
    }) || []), [myDom]);
  } else {
    return [myDom].concat((0, _toConsumableArray2["default"])(_react.Children.map(children, function (c) {
      return c;
    }) || []));
  }
};
var _default = exports["default"] = mergeChildren;
module.exports = exports.default;